import {
  CloudProvider,
  GraphsWithFlyProviderQuery,
} from 'src/lib/graphqlTypes/types';

export const getRouterIds = (data: GraphsWithFlyProviderQuery | undefined) => {
  if (!data?.account?.graphs) {
    return [];
  }

  return data.account.graphs.flatMap(({ variants }) => {
    return variants
      ?.filter(
        (variant) =>
          variant.router?.shard?.region.provider === CloudProvider.FLY,
      )
      .map((variant) => variant.router?.id)
      .filter(Boolean);
  });
};
